var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-myprofile.757ccd95.png","uri@2x": __webpack_public_path__ + "icon-myprofile.68e33dc8.png","uri@3x": __webpack_public_path__ + "icon-myprofile.58927f26.png",
    width: 38,
    height: 38
});